import Select2BaseController from './base_controller'

const countryMarkers = {
  A: '1F1E6',
  B: '1F1E7',
  C: '1F1E8',
  D: '1F1E9',
  E: '1F1EA',
  F: '1F1EB',
  G: '1F1EC',
  H: '1F1ED',
  I: '1F1EE',
  J: '1F1EF',
  K: '1F1F0',
  L: '1F1F1',
  M: '1F1F2',
  N: '1F1F3',
  O: '1F1F4',
  P: '1F1F5',
  Q: '1F1F6',
  R: '1F1F7',
  S: '1F1F8',
  T: '1F1F9',
  U: '1F1FA',
  V: '1F1FB',
  W: '1F1FC',
  X: '1F1FD',
  Y: '1F1FE',
  Z: '1F1FF',
}
const formatStateFlags = ({ id, text, element }) => {
  if (!id) {
    return text
  }
  const $state = $(
    `<span>&#x${countryMarkers[element.value[0]]};&#x${
      countryMarkers[element.value[1]]
    }; ${text}</span>`
  )
  return $state
}

// select2 Search Dropdown with Flags
// Usage: add "data-controller="select2--flags"" attribute to an HTML element
export default class extends Select2BaseController {
  connect() {
    $(this.element).select2({
      theme: 'bootstrap4',
      width: '100%',
      templateResult: formatStateFlags,
      templateSelection: formatStateFlags,
      placeholder: $(this.element).attr('placeholder') || '',
      selectionCssClass: 'select2-custom-selection',
      dropdownCssClass: 'select2-custom-dropdown',
    })

    super.connect()
  }
}
